import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ReceptaclesInPreconNotInPredesReport
  from '../../components/ReceptaclesInPreconNotInPredesReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptaclesInPreconNotInPredesDetailsSelectors';
import ReceptaclesInPreconNotInPredesReportMode from '../../components/ReceptaclesInPreconNotInPredesReportMode';

export class ReceptaclesInPreconNotInPredesDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: ReceptaclesInPreconNotInPredesReportMode.included,
      showTrafficButton: true,
    };
  }

  changeTrafficMode = () => {
    switch (this.state.reportMode) {
      case ReceptaclesInPreconNotInPredesReportMode.included:
        return this.setState({ reportMode: ReceptaclesInPreconNotInPredesReportMode.excluded });
      case ReceptaclesInPreconNotInPredesReportMode.excluded:
        return this.setState({ reportMode: ReceptaclesInPreconNotInPredesReportMode.included });
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  };

  renderIncluded() {
    return (
      <ReceptaclesInPreconNotInPredesReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data.filter(d => d.isTrafficInternal !== true)}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPreconNotInPredesReportMode.included}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  renderExcluded() {
    return (
      <ReceptaclesInPreconNotInPredesReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPreconNotInPredesReportMode.excluded}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case ReceptaclesInPreconNotInPredesReportMode.included:
        return this.renderIncluded();
      case ReceptaclesInPreconNotInPredesReportMode.excluded:
        return this.renderExcluded();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ReceptaclesInPreconNotInPredesDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ReceptaclesInPreconNotInPredesDetailsContainer);
